import "./widget_core.js"
import "../../../public/javascripts/backbone/lib/concerns/views/header_helpers.js"
import "../../../public/javascripts/backbone/lib/concerns/views/tabindex_helpers.js"
var req = require.context('../../../public/javascripts/backbone/apps/carousel/', true, /\.js$/)
req.keys().forEach(req)
